import { type FunctionComponent } from 'react';
import { ClickableElement } from '../../../../../components/buttons';
import { Carousel } from '../../../../../components/carousel/carousel.component';
import { CloudinaryImage } from '../../../../../components/images/cloudinary-image/cloudinary-image.component';
import { roomTags } from '../../../../../constants/project/shop-by-look';
import { generateRoomImagePublicId } from '../../../../../helpers/shop-by-look/shop-by-look.helper';
import type { RoomTag } from '../../../../../types/project.types';
import { roomsButton } from './filter-by-rooms.css';

export type FilterByRoomButtonProps = {
	room: RoomTag;
	selectedRooms: string[];
	onClick: (room: string) => void;
	testId?: string;
};

export const FilterByRoomButton: FunctionComponent<FilterByRoomButtonProps> = ({ room, selectedRooms, onClick, testId }) => {
	return (
		<ClickableElement
			ariaLabel={`${room.value} filter`}
			testId={testId}
			className={`pointer ${roomsButton} ${selectedRooms.includes(room.value.toLowerCase()) ? 'bg-theme-primary-lighter' : ''} br2`}
			onClick={() => onClick(room.value.toLowerCase())}>
			<div className="flex flex-column items-center" style={{ width: 120 }}>
				<CloudinaryImage
					publicID={generateRoomImagePublicId(room.iconName)}
					options={{ crop: 'lpad', width: 75, preserveTransparency: true }}
					description={`${room.value} icon`}
				/>
				<span className="nt1 mb1">{room.value.toUpperCase()}</span>
			</div>
		</ClickableElement>
	);
};

type RoomsButtonsBarProps = {
	selectedRooms: string[];
	onSelectedRoom: (room: string) => void;
	className?: string;
	size: 'large' | 'small';
};

const RoomsButtonsBar: FunctionComponent<RoomsButtonsBarProps> = ({ selectedRooms, onSelectedRoom, className, size }) => (
	<div className={className}>
		{roomTags.map((room) => (
			<FilterByRoomButton
				key={`${size}-${room.iconName}`}
				testId={`${size}-${room.iconName}-button`}
				room={room}
				onClick={onSelectedRoom}
				selectedRooms={selectedRooms}
			/>
		))}
	</div>
);

export type FilterByRoomsProps = {
	selectedRooms: string[];
	onSelectedRoom: (room: string) => void;
	isAllFavorites?: boolean;
};

export const FilterByRooms: FunctionComponent<FilterByRoomsProps> = ({ onSelectedRoom, selectedRooms, isAllFavorites }) => {
	return (
		<>
			{!isAllFavorites && (
				<span className="flex theme-grey-darker fw2 f2-ns f3 lh-title-ns lh-solid w-100 justify-center">Looks by Room</span>
			)}
			<RoomsButtonsBar
				selectedRooms={selectedRooms}
				onSelectedRoom={onSelectedRoom}
				className="dn flex-ns justify-around-l justify-center-m flex-wrap"
				size="large"
			/>
			<div className="db dn-ns">
				<Carousel>
					<RoomsButtonsBar
						selectedRooms={selectedRooms}
						onSelectedRoom={onSelectedRoom}
						className="flex justify-around"
						size="small"
					/>
				</Carousel>
			</div>
		</>
	);
};
